
import React from 'react';

interface HeroSectionProps {
  onOpenModal: () => void;
}

export default function HeroSection({ onOpenModal }: HeroSectionProps) {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f63f659817665d63883ff2fb431863ee.jpg"
          alt="Scale North Solutions background"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1F3A]/95 via-[#0B1F3A]/80 to-[#0B1F3A]/50"></div>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-8 lg:px-20 py-32 w-full">
        <div className="max-w-[680px]">
          <h1 className="text-[64px] leading-[1.08] font-semibold text-white mb-8">
            Technology that performs.<br />Growth you can measure.
          </h1>
          <p className="text-lg text-white/60 leading-relaxed max-w-[540px] mb-12">
            Scale North Solutions designs and implements intelligent systems for regulated, high-stakes industries — from healthcare and legal to wealth management and municipal operations.
          </p>
          <div className="flex items-center gap-4 mb-16">
            <button
              onClick={onOpenModal}
              className="bg-[#1EB6B0] text-white px-10 h-14 rounded-md text-base font-medium hover:bg-[#1EB6B0]/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Request Executive Consultation
            </button>
            <a
              href="#services"
              className="border border-white/30 text-white px-10 h-14 rounded-md text-base font-medium hover:border-white/60 transition-all flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              View Capabilities
            </a>
          </div>
          <div className="flex items-center gap-5">
            <div className="w-6 h-[1px] bg-white/30"></div>
            <p className="text-[13px] text-white/45">
              Built for compliance‑driven and performance‑sensitive organizations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
